export default {
    landing: 'landing',
    application: 'application',
    entry: 'entry', 
    admin: 'admin'
};